import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
	ecommerce: () => faker.company.name(),
	date: () => faker.date.past(1).toISOString(),
	price: () => `${parseFloat(faker.finance.amount(1, 1000))}€`,
});
